import { useState, useEffect, RefObject } from "react";

type Position = {
  xPos: number;
  yPos: number;
};

export const useScrollPosition = (
  ref?: RefObject<HTMLElement | null>,
): Position => {
  const [scrollPosition, setScrollPosition] = useState({ xPos: 0, yPos: 0 });

  useEffect(() => {
    // sets the scroll to watch, otherwise defaults to window
    const targetArea = ref?.current || window;

    const handleScroll = (event: Event) => {
      // same element as targetArea
      const eventTarget = event.target as HTMLElement;
      const newPosition = {
        xPos: eventTarget.scrollLeft,
        yPos: eventTarget.scrollTop,
      };
      setScrollPosition(newPosition);
    };

    targetArea.addEventListener("scroll", handleScroll);

    return () => {
      targetArea.removeEventListener("scroll", handleScroll);
    };
  }, [ref]);

  return scrollPosition;
};
